import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { AccordionContainer } from './AccordionContainer';

export function PrizeAccordion({ id }) {
  const [rewards, setRewards] = useState({});
  const [awards, setAwards] = useState([]);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    requestRewards();
  }, []);

  const requestRewards = async () => {
    try {
      const response = await axios.get(`https://api.sprinta.com.br/BenefitsProgram/get/event/${id}`);
      // console.log(response.errors); // Verifique a estrutura dos dados da resposta no console

      if(response.errors) {
        setLoading(false);
        return <div></div>;
      }
  
      // Atualize a desestruturação dos dados de acordo com a estrutura real
      const { rewards, awards, user } = response || {};
      const { next_award, shared_link, allow_benefits } = user || {};
  
      setRewards(rewards || {});
      setAwards(awards || []);
      setUser({ next_award, shared_link, allow_benefits });
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };
  
  
  
  
  if (loading) {
    return <div>verificando benefícios...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  
  if(!user || user.allow_benefits == false){
    return <div></div>;
  }

  const currentAward = awards.find((award) => user && award.id === user.next_award.id);
  const defaultItem = awards[0];

  return (
    <section style={{ marginTop: '0px' }}>
      {!user ? (
        <AccordionContainer
          image_url={defaultItem ? defaultItem.image : ''}
          title={defaultItem ? defaultItem.name : ''}
          price={defaultItem ? defaultItem.cost : ''}
          amount={0}
          onlyView={true}
          awards={[]}
          rewards={[]}
        />
      ) : (
        <AccordionContainer
          image_url={currentAward ? currentAward.image : ''}
          title={currentAward ? currentAward.name : ''}
          price={currentAward ? currentAward.cost : ''}
          amount={user.next_award ? user.next_award.amount : ''}
          awards={awards}
          rewards={rewards}
          user={user}
        />
      )}
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/pages/event/PrizeAccordion/index.jsx